import React, { Component } from 'react'
import AdministratorForm from '@modules/admin/administrators/Admin.Form'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { DashboardHeader } from '@modules/admin/Admin.Header'

class CreateAdministrator extends Component {
  state = {
    newAdmin: {},
  }

  render() {
    return (
      <div className="crud-wrapper">
        <DashboardHeader title={<Trans>Nuevo Administrador</Trans>}>
          <Link className="btn btn-primary" to={`/administrator`}>
            <Trans>Volver</Trans>
          </Link>
        </DashboardHeader>
        <div className="container-fluid main-content">
          <AdministratorForm initialValues={this.state.newAdmin} />
        </div>
      </div>
    )
  }
}

export default withTranslation()(CreateAdministrator)
